import React, { useEffect } from 'react';

function App() {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (
                e.key === 'F12' ||
                (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key)) ||
                (e.ctrlKey && e.key === 'U')
            ) {
                e.preventDefault();
            }
        };

        const handleRightClick = (e) => {
            e.preventDefault();
        };

        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('contextmenu', handleRightClick);

        // Load disable-devtool script from CDN
        if (typeof window.__ddid === 'undefined') {
            window.__ddid = setTimeout(() => {
                const script = document.createElement('script');
                script.src = 'https://cdn.jsdelivr.net/npm/disable-devtool';
                script.setAttribute('disable-devtool-auto', '');
                script.setAttribute('disable-menu', 'false');
                document.head.appendChild(script);
            }, 100);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('contextmenu', handleRightClick);
        };
    }, []);

    return (
        <>     </>
    );
}

export default App;
